import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Investments from "./InvestmentsCard/InvestmentsCard";
import PortfolioBalance from "./PortfolioBalance/PortfolioBalance";
import RecentTransactions from "./RecentTransactions/RecentTransactions";
import {
  getPortfolioAction, getPremiumFeeAction, getUserInfoAction, getUsersInvestmentAction, getWalletBalanceAction,
} from "../../../../features/user/userSlice";
import MarketPlaceCardShimmer from "../MarketPlace/MarketPlaceCardShimmer/MarketPlaceCardShimmer";
import { Col, Row } from "react-bootstrap";
import WalletValueCard from "./WalletValueCard/WalletValueCard";
import increesIcon from '../../../../assets/icons/increesIcon.svg'
import styles from "./Dashboard.module.scss";
import Select from "../../../common/Formik/Select/Select";
import { NavLink } from "react-router-dom";
import { DepositArrowIcon, ReciveBuyIcon, SendSellIcon, WithdrawArrowIcon, TransactionsIcon } from "../../../../assets/icons/svgicons";
import { ROUTES } from "../../../../routes";
import CommonBanner from "../../../common/CommonBanner/CommonBanner";
import gold from '../../../../assets/icons/asset-icons/gold.svg';
import silver from '../../../../assets/icons/asset-icons/silver.svg';
import Slider from "react-slick";
import chart from '../../../../assets/images/chartdemo.svg';
import RecentTransactionsnew from "./RecentTransactionsnew/RecentTransactionsnew";
import { formatPrice } from "../../../../utils/utils";
import TradingViewGoldChart from "../../../TradingViewChart/TradingViewGoldChart";
import TradingViewSilverChart from "../../../TradingViewChart/TradingViewSilverChart";
import { useBanner } from "../../../customHook/useBanner";

const Dashboard = () => {
  const dispatch = useDispatch();
  const timeOptions = [
    { label: "Weekly", value: "WEEK", timeUnit: "day", count: 1, },
    { label: "Today", value: "DAY", timeUnit: "hour", count: 2, },
    // { label: "Monthly", value: "MONTH", timeUnit: "month", count: 1,},
    // { label: "Yearly", value: "YEAR", timeUnit: "year", count: 1,},
  ];
  const [filter, setFilter] = useState(timeOptions[0]);
  const [priceChange, setPriceChange] = useState();
  const [percentageChange, setPercentageChange] = useState();
  const [portfolioBalance, setPortfolioBalance] = useState();
  const spotPrice = useSelector((state) => state?.users?.spotPrice);
  const spotPremiumPrice = useSelector((state) => state?.users?.spotPremiumPrice);

  const [goldData, setGoldData] = useState();
  const [silverData, setSilverData] = useState();
  const [equityData, setEquityData] = useState();
  const [loading, setLoading] = useState(true);
  const [quantityOrder, setQuantityOrder] = useState(false);
  const [priceOrder, setPriceOrder] = useState(false);
  const [averageOrder, setAverageOrder] = useState(false);
  const [investmentList, setInvestmentList] = useState([]);
  const [imageUrl, setImageUrl] = useState("");
  const kycStatus = useSelector(
    (state) => state?.persist?.userInfo?.kyc_status
  );
  const equityPrice = useSelector((state) => state?.users?.equityPrice);
  const getPortfolioData = async (data) => {
    try {
      const params = {
        dateFilterVal: filter?.value,
        // filterByToken: tokenId,
      };
      const res = await dispatch(getPortfolioAction(params));
      if (res.status === 200) {
        setGoldData(res?.data?.data?.find((item) => item.name === "Gold STBL"));
        setEquityData(res?.data?.data?.find((item) => item.name === "Equity"));
        setSilverData(
          res?.data?.data?.find((item) => item.name === "Silver STBL")
        );
      }
    } catch (error) {
      console.log("Error");
    }
  };
  const getUsersInvestment = async (data) => {
    try {
      let params = {};
      if (data === "Qty") {
        params.sortByQuantity = quantityOrder == true ? "ASC" : "DESC";
      }
      if (data === "Average") {
        params.sortByAverage = averageOrder == true ? "ASC" : "DESC";
      }
      if (data === "Price") {
        params.sortByPrice = priceOrder == true ? "ASC" : "DESC";
      }
      const response = await dispatch(getUsersInvestmentAction(params));
      if (response?.status === 200) {
        const userData = response.data.data?.getUserInvestments?.tokenSales;
        const imageUrlResponse = response?.data?.data?.imageUrl;
        setImageUrl(imageUrlResponse);
        setInvestmentList(userData);
      }
    } catch (error) {
      console.log("Something went wrong:", error);
    }
  };
  useEffect(() => {
    getUsersInvestment();
  }, []);

  useEffect(() => {
    getPortfolioData();
  }, [filter]);

  //     useEffect(() => {
  //   const goldBalance = goldData?.tokenBalance * spotPrice.goldPrice;

  //   const silverBalance = silverData?.tokenBalance * spotPrice.silverPrice;
  //   const equityBalance = equityData?.tokenBalance * equityPrice?.price;

  //   const portfolioBalance = goldBalance + silverBalance + equityBalance;
  //   setPortfolioBalance(portfolioBalance);

  //   const previousGoldValue = goldData?.tokenBalance * goldData?.price;
  //   const previousSilverValue = silverData?.tokenBalance * silverData?.price;
  //   const previousEquityBalance = equityData?.tokenBalance * equityData?.price;
  //   const previousPortfolioValue =
  //     previousGoldValue + previousSilverValue + previousEquityBalance;

  //   const priceChange = portfolioBalance - previousPortfolioValue;
  //   setPriceChange(priceChange);

  //   const percentageChange = (priceChange / portfolioBalance) * 100;
  //   setPercentageChange(percentageChange);
  // }, [spotPrice, filter]);

  useEffect(() => {

    const safeNum = (val) => Number(val ?? 0);
    const safeMul = (a, b) => safeNum(a) * safeNum(b);

    // ---- CURRENT VALUES ----
    const goldBalance = safeMul(goldData?.tokenBalance, spotPremiumPrice?.goldPrice);
    const silverBalance = safeMul(silverData?.tokenBalance, spotPremiumPrice?.silverPrice);
    const equityBalance = safeMul(equityData?.tokenBalance, equityPrice?.price);
    const portfolioBalance = goldBalance + silverBalance + equityBalance;
    setPortfolioBalance(portfolioBalance);

    // ---- PREVIOUS VALUES ----
    const previousGoldValue = safeMul(goldData?.tokenBalance, goldData?.averagePrice);
    const previousSilverValue = safeMul(silverData?.tokenBalance, silverData?.averagePrice);
    const previousEquityValue = safeMul(equityData?.tokenBalance, equityData?.averagePrice);

    const previousPortfolioValue =
      previousGoldValue + previousSilverValue + previousEquityValue;

    // ---- PRICE CHANGE ----
    const priceChange = safeNum(portfolioBalance) - safeNum(previousPortfolioValue);
    setPriceChange(priceChange);


    // ---- PERCENTAGE CHANGE ----
    const percentageChange = portfolioBalance > 0 ? (priceChange / portfolioBalance) * 100 : 0;

    setPercentageChange(percentageChange);
  }, [spotPrice, filter]);

  useEffect(() => {
    getUserProfile();
    getWalletBalance();
    adminPremiumFee();
  }, [kycStatus]);


  const getUserProfile = async () => {
    const response = await dispatch(getUserInfoAction());
    if (response?.data?.data) {
      setLoading(false);
    }
  };

  const getWalletBalance = async () => {
    try {
      await dispatch(getWalletBalanceAction());
    } catch (error) {
      console.log(error);
    }
  };

  const adminPremiumFee = async () => {
    await dispatch(getPremiumFeeAction());
  };
  const Options = [
    { value: "1Days", label: "1 Days" },
    { value: "7Days", label: "7 Days" },
    { value: "1Month", label: "1 Month" },
    { value: "3Month", label: "3 Month" },
    { value: "6Month", label: "6 Month" },
    { value: "1Year", label: "1 Year" },
  ];
  const linksdata = [
    {
      to: ROUTES.WALLETPORTFOLIO, icons: <DepositArrowIcon />,
      linklabel: "Deposit", state: { type: "deposit" }, style: { background: "#787FFF", borderColor: "#787FFF", color: "white", svg: { path: { fill: "white" }, }, }
    },
    {
      to: ROUTES.WALLETPORTFOLIO,
      icons: <WithdrawArrowIcon />,
      linklabel: "Withdraw",
      state: { type: "withdraw" }
    },
    { to: ROUTES.MARKETPLACE, icons: <ReciveBuyIcon />, linklabel: "Buy" },
    { to: ROUTES.MARKETPLACE, icons: <SendSellIcon />, linklabel: "Sell" },
    { to: ROUTES.WALLETPORTFOLIO, icons: <TransactionsIcon />, linklabel: "Convert", state: { tab: "crypto" } },
  ];

  const cardsholdingdata = investmentList?.map((item) => ({
    titles: "Your Holding",
    coinicon: imageUrl + item.image,
    cointitles: item.name,
    coininfo: item.name.includes("Gold")
      ? "Backed by physical gold"
      : "Backed by physical silver",
    coinvalue: `$${formatPrice(
      Number(item.quantity) * (item.name === "Gold STBL"
        ? spotPrice?.goldPrice
        : spotPrice?.silverPrice)
    )}`,
    coingrowth: `${formatPrice(Number(item.changePerc))}%`,
    quantityvalue: `${item.quantity} ${item.name === "Gold STBL" ? "GSTBL" : "SSTBL"}`,
    pertokenvalue: `$${formatPrice(
      item.name === "Gold STBL"
        ? spotPrice?.goldPrice
        : spotPrice?.silverPrice
    )}`
  }));

  const settings = {
    dots: true,
    infinite: false,
    arrow: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        dots: true,
        arrow: false,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const { data, loadingBanner } = useBanner("DASHBOARD");
  return (
    <>
      <section className={styles.dashboard}>
        <div className={styles.dashboard_topHead}>
          <div className={styles.selectvalues}>
            <p>
              <img src={increesIcon} alt="icons" />
              {formatPrice(Number(percentageChange))}%
            </p>
            {/* <Select
              variant="border_dark small_height"
              className={styles.select_time}
              options={Options}
              formatOptionLabel={(option) => <h5>{option.label}</h5>}
              placeholder={<h5>All</h5>}
              isSearchable={false}
              defaultValue={Options[0]}
              // onChange={(selectedOption) =>
              //   handleFilterChange("transactionType", selectedOption?.value)
              // }
            /> */}
          </div>
          <div className={styles.dashboard_topHead_inner}>
            <div className={styles.dashboard_topHead_inner_leftvalues}>
              <label>Total Portfolio Balance</label>
              <h2 className="big">
                $<span>{formatPrice(Number(portfolioBalance))}</span>
              </h2>
            </div>
            <div className={styles.dashboard_topHead_inner_rightLinks}>
              <ul className={styles.listlink}>
                {linksdata.map((items, index) => (
                  <li key={index}>
                    <NavLink
                      to={items.to}
                      className="links"
                      state={items.state}
                      style={items?.style}
                    >
                      <span className={styles.iconlink}>{items.icons}</span>
                      {items.linklabel}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        {/* <CommonBanner
          className="dashboard_banner"
          title="Gold is the timeless hedge against uncertainty."
          subtitle="John Doe"
          // bannerImg={data?.imageUrl + data?.image}
          // loadingBanner={loadingBanner}
        /> */}

        <CommonBanner
          className="dashboard_banner"
          title={
            loadingBanner
              ? "Loading banner..."
              : data?.banner_text ||
              "Gold is the timeless hedge against uncertainty."
          }
          subtitle={data?.banner_title || "John Doe"}
        // loadingBanner={loadingBanner}
        />

        <div className={styles.dashboard_holdingcard}>
          <Slider {...settings}>
            {cardsholdingdata.map((items, index) => (
              <div className={styles.cardhold} key={index}>
                <h4>{items.titles}</h4>
                <div className={styles.cardvalues}>
                  <div className={styles.cardvalues_leftdata}>
                    <div className={styles.cardIcons}>
                      <img src={items.coinicon} alt="icons-card" />
                    </div>
                    <div className={styles.cardTexts}>
                      <h4>{items.cointitles}</h4>
                      <h6>{items.coininfo}</h6>
                    </div>
                  </div>
                  <div className={styles.cardvalues_rightdata}>
                    <h4>{items.coinvalue}</h4>
                    <h6>{items.coingrowth}</h6>
                  </div>
                </div>
                <div className={styles.cardFooter}>
                  <div className={styles.cardFooter_leftdata}>
                    <label>Quantity</label>
                    <h6>{items.quantityvalue}</h6>
                  </div>
                  <div className={styles.cardFooter_rightdata}>
                    <label>Price per token</label>
                    <h6>{items.pertokenvalue}</h6>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
        <div className={styles.dashboard_rechartsdata}>
          <Row>
            <Col lg={6} md={6}>
              <div className={styles.chartcard}>
                <h4>Gold Activities</h4>
                <div className={styles.chartimg} style={{ height: "400px" }}>
                  <TradingViewGoldChart />
                </div>
              </div>
            </Col>
            <Col lg={6} md={6}>
              <div className={styles.chartcard}>
                <h4> Silver Activities</h4>
                <div className={styles.chartimg} style={{ height: "400px" }}>
                  <TradingViewSilverChart />
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <RecentTransactionsnew />
      </section>
      {/* {loading === true ? (
        <Row>
          {Array.from({ length: 3 }).map((item, index) => (
            <Col sm={6} lg={4} key={index}>
              <MarketPlaceCardShimmer />
            </Col>
          ))}
        </Row>
      ) : (
        // <LoaderIcon />
        <div className={styles.dashboard}>
          <div
            className={kycStatus !== "verified" ? styles.kyc_grid : styles.grid}
          >
            <div className={styles.item1}>
              <PortfolioBalance />
            </div>
            <div className={styles.item2}>
              <WalletValueCard />
            </div>
            <div className={styles.item3}>
              <Investments className={styles.investments} viewButton={true} />
            </div>
            <div className={styles.item4}>
              <RecentTransactions />
            </div>
          </div>
        </div>
      )} */}
    </>
  );
};

export default Dashboard;
